module.exports = __webpack_public_path__ + "83bdf16e6b77c28f5b04ce2d4d82e77c.png";